import w1 from '@/assets/img/gallery/wishList-01.jpg'
import w2 from '@/assets/img/gallery/wishList-02.jpg'
import w3 from '@/assets/img/gallery/wishList-03.jpg'
import w4 from '@/assets/img/gallery/wishList-04.jpg'
import w5 from '@/assets/img/gallery/wishList-05.jpg'

export const wishListData = [
    {
        image:w1,
        name:'Sofa',
        price: '$65.90',
        desc:'Modern Sofa Set'
    },
    {
        image:w2,
        name:'Interior',
        price: '$99.90',
        desc:'Classic Chair with Vase'
    },
    {
        image:w3,
        name:'Lamp',
        price: '$30.90',
        desc:'Luxury Hanging Lamp'
    },
    {
        image:w4,
        name:'Vase',
        price: '$56.90',
        desc:'Premium Quality Vase'
    },
    {
        image:w5,
        name:'Chair',
        price: '$50.00',
        desc:'Classic White Chair'
    },
]

export const cartList = [
    {
        image:w1,
        name:'Sofa',
        value:'$65.90',
        desc:'Modern Sofa Set'
    },
    {
        image:w2,
        name:'Interior',
        value:'$99.90',
        desc:'Classic Chair with Vase'
    },
    {
        image:w3,
        name:'Lamp',
        value:'$30.90',
        desc:'Luxury Hanging Lamp'
    },
    {
        image:w4,
        name:'Vase',
        value:'$20.00',
        desc:'Premium Quality Vase'
    },
]

export const footerLink1 = [
    {
        name:'About',
        link:'/about'
    },
    {
        name:'Portfolio',
        link:'/portfolio-v1'
    },
    {
        name:'Clients',
        link:'/our-clients'
    },
    {
        name:'FAQs',
        link:'/faq'
    },
    {
        name:'Contact',
        link:'/contact'
    },
]
export const footerLink2 = [
    {
        name:'Request Quote',
        link:'/request-quotation'
    },
    {
        name:'Terms & Conditions',
        link:'/terms-and-conditions'
    },
    {
        name:'My Account',
        link:'/my-profile'
    },
    {
        name:'Order History',
        link:'/order-history'
    },
]
export const footerLink3 = [
    {
        name:'Shop',
        link:'/shop-v2'
    },
    {
        name:'Browse Products',
        link:'/shop-v2'
    },
    {
        name:'Cart',
        link:'/cart'
    },
    {
        name:'Checkout',
        link:'/checkout'
    },
    {
        name:'Wishlist',
        link:'/wishlist'
    },
]
export const footerLink4 = [
    {
        name:'Contact',
        link:'/contact'
    },
    {
        name:'Terms & Condition',
        link:'/terms-and-conditions'
    },
    {
        name:'About',
        link:'/about'
    },
    {
        name:'Request Quote',
        link:'/request-quotation'
    },
]
